import { render, staticRenderFns } from "./captcha.vue?vue&type=template&id=fd2ee934&scoped=true&"
import script from "./captcha.js?vue&type=script&lang=js&"
export * from "./captcha.js?vue&type=script&lang=js&"
import style0 from "./captcha.css?vue&type=style&index=0&id=fd2ee934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2ee934",
  null
  
)

export default component.exports